import { Cancel, Check, Flag, People, PlayCircle } from '@mui/icons-material'
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import {
  Operations as IncidentReportOperations,
  operations as incidentReportOperations
} from 'states/dux/incident-report/operations'
import { Payload as IncidentReportPayload } from 'states/dux/incident-report/types'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { IncidentReport } from 'types/incident-report'
import { NivosUser } from 'types/user'
import {
  get,
  mapOperationsToDispatchProps,
  objectifyDateStringFields,
  post,
  trusty
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  incidentReport: IncidentReportPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    incidentReport: IncidentReportOperations
  }
}

interface OwmProps {
  report: IncidentReport
  useIconButton?: boolean
}

interface SelectOptions {
  label: string
  value: number
}

type AppProps = StateProps & DispatchProps & OwmProps

const IncidentActionButtonsFC: React.FC<any> = (props: AppProps) => {
  const { report, operations, useIconButton } = props
  const [assignDialog, setAssignDialog] = React.useState(false)

  const acceptReport = (): void => {
    void post(`/report/${report.id}/accept/`, {}).then(data => {
      operations.incidentReport.update(objectifyDateStringFields(data))
    })
  }

  const declineReport = (): void => {
    void post(`/report/${report.id}/decline/`, {}).then(data => {
      operations.incidentReport.update(objectifyDateStringFields(data))
    })
  }

  const updateReportStatus = (statusCode: string): void => {
    void post(`/report/${report.id}/update_status/`, {
      status: statusCode
    }).then(data => {
      operations.incidentReport.update(objectifyDateStringFields(data))
    })
  }

  const assignUserToReport = (userId: number): void => {
    void post(
      `/report/${report.id}/`,
      { managed_by: userId, status: 'ASS' },
      false,
      false,
      'PUT'
    ).then(data => {
      operations.incidentReport.update(objectifyDateStringFields(data))
    })
  }

  const [userSelection, setUserSelection] = React.useState<SelectOptions>()

  const [userSelectOption, setUserOption] = React.useState<SelectOptions[]>([])

  React.useEffect(() => {
    if (userSelectOption.length < 1) {
      void get('/account/').then((data: NivosUser[]) => {
        try {
          setUserOption(
            data.map(item => ({ label: item.fullName, value: item.id }))
          )
        } catch (e) {
          console.log(e)
        }
      })
    }
  }, [])

  const AssignUserDialog: React.FC = () => {
    return (
      <Dialog open={assignDialog}>
        <DialogTitle>Assing User</DialogTitle>
        <DialogContent>
          <Box width={250} height={75}>
            <Box display={'flex'} alignItems={'center'} padding={1}>
              <Box width={1}>
                <Autocomplete
                  disablePortal
                  options={userSelectOption}
                  value={userSelection}
                  onChange={(event, value) => {
                    if (value !== null) {
                      setUserSelection(value)
                    }
                  }}
                  renderInput={params => (
                    <TextField {...params} label="Assigned Person" />
                  )}
                />
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'space-evenly',
            paddingBottom: 3
          }}
        >
          <Button
            variant={'contained'}
            onClick={() => {
              if (userSelection !== undefined) {
                assignUserToReport(userSelection.value)
                setAssignDialog(false)
              }
            }}
          >
            Assign
          </Button>
          <Button variant={'contained'} onClick={() => setAssignDialog(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <>
      <AssignUserDialog />
      {report.status === 'Pending' && (
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
          {trusty(useIconButton) && (
            <>
              <Tooltip title={'Accept'}>
                <IconButton
                  onClick={() => acceptReport()}
                  sx={{ marginRight: 2 }}
                >
                  <Check />
                </IconButton>
              </Tooltip>
              <Tooltip title={'Decline'}>
                <IconButton onClick={() => declineReport()}>
                  <Cancel />
                </IconButton>
              </Tooltip>
            </>
          )}
          {!trusty(useIconButton) && (
            <>
              <Button
                variant={'outlined'}
                size={'large'}
                startIcon={<Check />}
                onClick={() => acceptReport()}
                sx={{ marginRight: 2 }}
              >
                <Typography variant={'h5'}>ACCEPT</Typography>
              </Button>
              <Button
                variant={'outlined'}
                size={'large'}
                startIcon={<Cancel />}
                onClick={() => declineReport()}
              >
                <Typography variant={'h5'}>Decline</Typography>
              </Button>
            </>
          )}
        </Box>
      )}
      {report.status === 'Accepted' && (
        <>
          {trusty(useIconButton) && (
            <Tooltip title={'Assign to someone'}>
              <IconButton onClick={() => setAssignDialog(true)}>
                <People />
              </IconButton>
            </Tooltip>
          )}
          {!trusty(useIconButton) && (
            <Button
              variant={'outlined'}
              size={'large'}
              startIcon={<People />}
              onClick={() => setAssignDialog(true)}
            >
              <Typography variant={'h5'}>Assign to someone</Typography>
            </Button>
          )}
        </>
      )}
      {report.status === 'Assigned' && (
        <>
          {trusty(useIconButton) && (
            <Tooltip title={'Start progress'}>
              <IconButton onClick={() => updateReportStatus('INP')}>
                <PlayCircle />
              </IconButton>
            </Tooltip>
          )}
          {!trusty(useIconButton) && (
            <Button
              variant={'outlined'}
              size={'large'}
              startIcon={<PlayCircle />}
              onClick={() => updateReportStatus('INP')}
            >
              <Typography variant={'h5'}>Start progress</Typography>
            </Button>
          )}
        </>
      )}
      {report.status === 'In-Progress' && (
        <>
          {trusty(useIconButton) && (
            <Tooltip title={'Resolve'}>
              <IconButton onClick={() => updateReportStatus('RES')}>
                <Flag />
              </IconButton>
            </Tooltip>
          )}
          {!trusty(useIconButton) && (
            <Button
              variant={'outlined'}
              size={'large'}
              startIcon={<Flag />}
              onClick={() => updateReportStatus('RES')}
            >
              <Typography variant={'h5'}>RESOLVE</Typography>
            </Button>
          )}
        </>
      )}
    </>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    incidentReport: state.incidentReport
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  incidentReport: incidentReportOperations
})

const IncidentActionButtons = connect(
  mapStateToProps,
  mapDispatchToProps
)(IncidentActionButtonsFC) as React.FC<OwmProps>

export default IncidentActionButtons
